export const transactionSignalTypeLabels = {
  BANK_ACCOUNT_AVERAGE_DAILY_BALANCE: 'Bank Account Average Daily Balance',
  CRYPTO_TRADING: 'Crypto Trading',
  GAMBLING: 'Gambling',
  LOAN: 'Loan',
  MCA: 'MCA',
  NSF: 'NSF',
  OVERDRAFT: 'Overdraft',
  PAYDAY: 'Payday',
  ROUND_NUMBER_DISTRIBUTION: 'Round Number Distribution',
  VIOLATING_DIGIT: 'Violating Digit',
  BANK_ACCOUNT_BALANCE: 'Bank Account Balance',
};

export const transactionSignalLabels = {
  type: 'Type',
  flagged: 'Flagged',
  count_loan_repayments: 'Count Loan Repayments',
  count_loan_disbursements: 'Count Loan Disbursements',
  total_loan_repayments: 'Total Loan Repayments',
  total_loan_disbursements: 'Total Loan Disbursements',
  merchants: 'Merchants',
  count_unique_merchants: 'Count Unique Merchants',
  count_debits: 'Count Debits',
  count_credits: 'Count Credits',
  count_repayments: 'Count Repayments',
  count_disbursements: 'Count Disbursements',
  total_repayments: 'Total Repayments',
  total_disbursements: 'Total Disbursements',
  total_debits: 'Total Debits',
  total_credits: 'Total Credits',
  average_daily_balance: 'Average Daily Balance',
  adb_divided_by_total_credits: 'ADB Divided by Total Credits',
  proportion_round_numbers: 'Proportion Round Numbers',
  leading_digit: 'Leading Digit',
  frequency: 'Frequency',
  relative_frequency_to_benfords_law: 'Relative Frequency to Benfords Law',
  benfords_law_expected_frequency: 'Benfords Law Expected Frequency',
  bank_account_id: 'Bank Account ID',
  average_daily_balance_over_total_credits:
    'Average Daily Balance Over Total Credits',
};

const centsToDollars = (cents) => (cents / 100).toFixed(2);

export const valuesTransformFn = {
  average_daily_balance: centsToDollars,
  total_repayments: centsToDollars,
  total_disbursements: centsToDollars,
  total_debits: centsToDollars,
  total_credits: centsToDollars,
  total_loan_repayments: centsToDollars,
  total_loan_disbursements: centsToDollars,
};
